import { useState } from 'react';

import config from '@/config';
import useQuery from '@/hooks/useQuery';
import useTranslations from '@/i18n/useTranslations';
import SearchBarIcon from '@/shared-components/icons/components/forms/SearchBarIcon';
import Loader from '@/shared-components/loader/Loader';
import Text from '@/shared-components/text/components/Text';

import VirtualList from './virtual-list';

import './index.css';

export default function Search({ selectedArtworks, setSelectedArtworks, maxSelectedArtworks }) {
  const t = useTranslations('common.profile.pages.artlist');
  const [query, setQuery] = useState({ q: "" });
  const { loading, queryData, loadMoreData } = useQuery(
    `search_artworks`,
    `${config.apis.api.url}/search/artwork`,
    query,
    {
      injectToken: true,
    }
  );

  return (
    <>
      <div className="artlist-add-artworks__search-bar">
        <SearchBarIcon className="artlist-add-artworks__search-icon" />

        <input
          type="text"
          className="artlist-add-artworks__search-input"
          value={query.q}
          onInput={(e) => setQuery({ q: e.target.value })}
          placeholder={t('add_artworks.search.placeholder')}
          spellCheck={false}
          autoComplete="off"
        />
      </div>
      <div className="artlist-add-artworks__artworks-container">
        {loading ? (
          <Loader className="artlist-add-artworks__spinner" thin />
        ) : queryData.data.data.length === 0 ? (
          <Text className="artlist-add-artworks__empty-text" paragraph>
            {t('add_artworks.search.empty')}
          </Text>
        ) : (
          <VirtualList
            key={queryData.queryString}
            items={queryData.data}
            onLoadMore={loadMoreData}
            selectedArtworks={selectedArtworks}
            setSelectedArtworks={setSelectedArtworks}
            maxSelectedArtworks={maxSelectedArtworks}
          />
        )}
      </div>
    </>
  );
}
